import { defineStore } from 'pinia';
import { AuthService } from '@/services/auth.service';
import { LoginPayload, User } from '@/types/auth';
import { useToast } from 'vue-toastification';

interface AuthState {
  user: User | null;
  token: string | null;
  loading: boolean;
  error: string | null;
  retail_token: string | null;
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    user: AuthService.getCurrentUser(),
    token: AuthService.getToken(),
    loading: false,
    error: null,
    retail_token: null,
  }),

  getters: {
    currentUser: (state) => state.user,
    isAuthenticated: (state) => !!state.token
  },

  actions: {
    setUser(user: User | null) {
      this.user = user;
    },
    setToken(token: string | null) {
      this.token = token;
    },
    setRetailToken(token: string | null) {
      this.token = token;
    },
    clearAuth() {
      this.user = null;
      this.token = null;
      this.retail_token = null;
    },
    async login(payload: LoginPayload) {
      const toast = useToast();
      this.loading = true;
      this.error = null;
      
      try {
        const response = await AuthService.login(payload);
        this.user = response.data.user;
        this.token = response.data.token;
        this.retail_token = response.data.retail_auth.token;
        toast.success(response.message);
        return true;
      } catch (error: any) {
        this.error = error.response?.data?.message || 'Login failed';
        toast.error(this.error);
        return false;
      } finally {
        this.loading = false;
      }
    },

    async logout() {
      const toast = useToast();
      try {
        await AuthService.logout();
        this.user = null;
        this.token = null;
        this.retail_token = null;
        toast.success('Logged out successfully');
      } catch (error: any) {
        toast.error('Logout failed');
      }
    }
  }
}); 